import {codeSvg as Icon__small__codeSvg} from '../Icon__small/Icon__small--code.js'
import {codeSvg as Icon__xsmall__codeSvg} from '../Icon__xsmall/Icon__xsmall--code.js'

export var code = {
  name: 'code',
  category: 'icon',
  colorable: true,
  svg: Icon__small__codeSvg,
  alt: {
    Icon__small: Icon__small__codeSvg,
    Icon__xsmall: Icon__xsmall__codeSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
